import { module as BaseModule } from "modujs";

const SELECTORS = {
  images: "[data-image-carousel-image]",
  texts: "[data-image-carousel-text]",
};

const CLASS_SHOWING = "is-showing";
const DEFAULT_DELAY = 5000; // ms

export default class ImageCarousel extends BaseModule {
  init() {
    this.images = Array.from(this.el.querySelectorAll(SELECTORS.images));
    this.texts = Array.from(this.el.querySelectorAll(SELECTORS.texts));

    this.count = Math.min(this.images.length, this.texts.length);
    if (this.count <= 1) {
      return;
    }

    this.current = this.findInitialIndex();
    this.intervalId = null;

    this.next = this.next.bind(this);
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);

    this.start();
  }

  findInitialIndex() {
    const imageIndex = this.images.findIndex((node) =>
      node.classList.contains(CLASS_SHOWING)
    );
    const textIndex = this.texts.findIndex((node) =>
      node.classList.contains(CLASS_SHOWING)
    );

    const idx = imageIndex !== -1 ? imageIndex : textIndex;
    return idx !== -1 ? idx : 0;
  }

  next() {
    const nextIndex = (this.current + 1) % this.count;
    this.showIndex(nextIndex);
  }

  showIndex(target) {
    const currentImage = this.images[this.current];
    const currentText = this.texts[this.current];

    if (currentImage) currentImage.classList.remove(CLASS_SHOWING);
    if (currentText) currentText.classList.remove(CLASS_SHOWING);

    const nextImage = this.images[target];
    const nextText = this.texts[target];

    if (nextImage) nextImage.classList.add(CLASS_SHOWING);
    if (nextText) nextText.classList.add(CLASS_SHOWING);

    this.current = target;
  }

  start() {
    this.stop();
    this.intervalId = window.setInterval(this.next, DEFAULT_DELAY);
  }

  stop() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  destroy() {
    this.stop();
  }
}
